import { appstr } from "../utils/appstr";
import { bookRenderInfo } from "../utils/bookRenderInfo";
import { DoAutoZoom } from "../utils/DoAutoZoom";
import { doPageRender } from "../utils/doPageRender";
import { doSVGRender } from "../utils/doSVGRender";
import { QStream } from "./QStream.js";
import { CenterIt } from "../utils/CenterIt.js";
import { GetExtension } from "../utils/GetExtension.js";
import { WSImageLoaded } from "../utils/WSImageLoaded.js";
// import QImageElement TODO fix circular import
import {
  enumBookScope,
  enumBookType,
  enumKeyboardTargetEnterAction,
  enumPageOrientationOptions,
  enumPageStep,
  enumPanelMode,
  enumPanelRenderMode,
  enumPubDest,
  enumRenderStep,
  enumUIModes,
  enumXMLType,
  kAlertHeight,
  kAlertWidth,
  kMaxStringLength,
  kPDFPageSizes
} from "../constants";
import { FinishPubResult } from "../utils/FinishPubResult";
import { isInPlanning } from "../utils/isInPlanning";
import { MyXMLSerializer } from "../utils/MyXMLSerializer";
import { handleBookAdvance } from "../utils/handleBookAdvance";
import { QAlert } from "./QAlert";
import { QAltCanvas } from "./QAltCanvas";
import { QBasePanel } from "./QBasePanel";
import { QCleanupPublishRFC } from "./QCleanupPublishRFC";
import { QCopyPubRFC } from "./QCopyPubRFC";
import { QCreatePubDoc } from "./QCreatePubDoc";
import { QCreateSVGRFC } from "./QCreateSVGRFC";
import { QGoogleAlert } from "./QGoogleAlert";
import { QGoogleAuthRFC } from "./QGoogleAuthRFC";
import { QPoint } from "./QPoint";
import { QWaitingPanel } from "./QWaitingPanel";
import { QPublishScaler } from "./QPublishScaler";
import { removeDiacritics } from "../utils/removeDiacritics";
import { SecureBufferEW } from "../utils/SecureBufferEW";
import { SecureBufferW } from "../utils/SecureBufferW";
import { SetOnBeforeUnload } from "../utils/SetOnBeforeUnload";
import { startprtimer } from "../utils/startprtimer";
import { StripExtension } from "../utils/StripExtension";
import { svgRenderInfo } from "../utils/svgRenderInfo";
import { XML_CreateDoc } from "../utils/XML_CreateDoc";
import { preFlightInfo } from "./preFlightInfo";
import { Globals } from "./Globals";
import { MapPageSizeToString } from "../utils/MapPageSizeToString";
import { ReportToWebDriver } from "../utils/ReportToWebDriver";
import { doPagePreFlight } from "../utils/doPagePreFlight";
import { QImageElement } from "./QImageElement.js";

export class QPublishPanel extends QBasePanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fCanvasPanel = null;
    //this.fSVGElement = null;

    this.fUserName = null;
    this.fFileName = null;

    this.fCanvasSizeX = null;
    this.fCanvasSizeY = null;

    this.fWaiting = null;
    this.fResolve = null;

    this.fSVGFileName = null;
    this.fPNGFileName = null;
    this.fJPGFileName = null;
    this.fXMLFileName = null;
    this.fPDFFileName = null;
    this.fPPTFileName = null;

    this.fNeedGenSVG = true;
    this.fNeedGenPNG = true;
    this.fNeedGenJPG = true;

    this.fPubScope = enumBookScope.entire;

    this.fTransparent = false;
    this.fHIRESPNG = false;

    this.fCropToChart = false;
    this.fPubWidth = null;
    this.fPubHeight = null;
    this.fShiftX = null;
    this.fShiftY = null;
    this.fDoSCArrows = true;

    this.fCreatePreview = null;

    this.fPDFPageSize = null;
    this.fPDFOrientation = null;
    this.fPDFCustomSize = null;

    this.fBookType = null;
    this.fXMLOutputType = null;

    this.fCurShowSCNum = null;
    this.fLastWorkingPage = -1;

    this.fCurrentSC = null;

    this.fForceAspectRatio = null;
  }

  // 1. Render the SVG Image
  // 2. Upload it the server
  // 3. Optionally, Server converts to png and saves result on the server
  // 4. Image is created and loaded into an ImageElement which is in this panel (PreviewResult)
  CalcCanvasParams(cropToChart) {
    var cp = this.fCanvasPanel;
    var pageMgr = cp.GetPageMgr();
    var plm = cp.GetPageLayoutMgr();

    //var cropToChart = this.fCropToChart;
    var sw = plm.GetPageWidth();
    var sh = plm.GetPageHeight();
    var dx = 0;
    var dy = 0;

    this.fShiftX = null;
    this.fShiftY = null;

    if (cropToChart) {
      var r = plm.GetTotalBounds(true, true);
      if (r != null) {
        // Add a buffer of 1 pixel around the crop
        if (r.fLeft >= 1) r.fLeft--;
        if (r.fTop >= 1) r.fTop--;
        if (r.fRight <= sw - 1) r.fRight++;
        if (r.fBottom <= sh - 1) r.fBottom++;

        sw = r.fRight - r.fLeft;
        sh = r.fBottom - r.fTop;
        dx = -r.fLeft;
        dy = -r.fTop;

        this.fShiftX = dx;
        this.fShiftY = dy;
      }
    }

    this.fPubWidth = sw;
    this.fPubHeight = sh;
  }

  //=======================================================================================
  // Render chart as SVG
  RemoveWaiting(isCompleted) {
    if (this.fResolve) this.fResolve(isCompleted);

    if (this.fWaiting != null) {
      Globals._wsMgr.ClearAppLoadingAnimation();
      Globals._timerMgr.ClearTimer();
      this.fWaiting = null;
      this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
      this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
      this.fWSMgr.RenderWS();
    }
  }

  UpdateProgress(msg, workingPage, totalPages) {
    if (workingPage == this.fLastWorkingPage) return;

    if (msg == null) {
      this.fLastWorkingPage = workingPage;
      msg =
        appstr("renderpdf") +
        " " +
        workingPage.toString() +
        " " +
        appstr("of") +
        " " +
        totalPages.toString();
    }
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.UpdateProgress2(msg, false);
  }

  CancelAction() {
    Globals._preflightInfo = null;
    Globals._bookRenderInfo = null;
    this.RemoveWaiting(false);

    this.DoAfterPublish();
  }

  // CancelAction clears _bookRenderInfo, which also stops a book export at the failed page.
  ReportExportFailure(failure) {
    this.CancelAction();

    var ref = failure.ref;
    ReportToWebDriver("Fail - Publish Failed" + (ref ? " [" + ref + "]" : ""));

    var alert = new QAlert();
    alert.InitAlert(
      appstr("exportFailedTitle"),
      appstr("exportFailedMsg"),
      this.fWSMgr,
      this.fWSMgr,
      true
    );
    this.fWSMgr.PrepRenderWS();
    this.fWSMgr.RenderWS();
  }

  DoAfterPublish() {
    var w = this.fWSMgr;
    var planMgr = w.fPlanManager;
    var inPlanningMode = isInPlanning();

    if (inPlanningMode) {
      if (planMgr && planMgr.fTempSavedMarginRect != null) {
        var docMgr = w.GetDocMgr();
        var pageMgr = docMgr.GetPageMgr();
        planMgr.RestorePageContentPubMargin(pageMgr);
      }
    }

    this.ResetPub(true);
  }

  DoWaiting(msg, addCancel) {
    this.fLastWorkingPage = -1;
    this.fWaiting = new QWaitingPanel();
    this.fWaiting.InitWaitingPanel(msg, this.fBackgroundPanel, this.fWSMgr, 250);
    ReportToWebDriver(msg);
    if (addCancel) this.fWaiting.AddCancel(this);
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fWSMgr.RenderWS();
  }

  RenderXML(
    altCanvas,
    cropToChart,
    scaleToPage,
    pageWidth,
    pageHeight,
    xml_doc,
    pageNum,
    bookmark,
    renderstep,
    renderScale,
    divSwitch
  ) {
    var cp = this.fCanvasPanel;
    if (renderstep != enumRenderStep.closepage) {
      xml_doc.StartPage(pageNum, bookmark, divSwitch);
      xml_doc.fIncludeSCArrows = this.fDoSCArrows;
      altCanvas = new QAltCanvas();
      altCanvas["orgpath"] = this.fWSMgr.GetOrgPath();
      altCanvas.InitAltCanvas("XML", xml_doc, true);
    }

    if (cropToChart) {
      altCanvas.SetShift(this.fShiftX, this.fShiftY);
    } else if (scaleToPage) {
      if (renderScale) {
        altCanvas.SetScale(renderScale);
        altCanvas.SetShift(this.fShiftX, this.fShiftY);
      }
    }
    cp.SetRenderMode(this.fHideMaster ? enumPanelRenderMode.contentOnly : enumPanelRenderMode.all);

    cp.SetAltCanvas(altCanvas);
    cp.RenderElements();
    cp.SetAltCanvas(null);

    if (renderstep != enumRenderStep.openpage) xml_doc.EndPage();

    return altCanvas;
  }

  XMLPost(transaction, cropToChart, filename, overwrite, xmlDoc) {
    xmlDoc.Close();
    var theData = xmlDoc.JoinStream();
    //var eData = ubtoa(theData);

    var curOrg = this.fWSMgr.GetAccountName();

    var s = new QStream();
    s.InitStream();
    s.Write(curOrg);
    s.Write(filename);
    s.Write(overwrite);
    s.Write(theData);

    var j = s.JoinStream();
    var postData = SecureBufferEW(this.fWSMgr, j);
    transaction.SetPostBuffer(postData);
    Globals._rfcMgr.QueueRFC(transaction);
  }

  GetBookType() {
    return this.fBookType;
  }

  PublishBook(
    pubScope,
    bookType //doBranch
  ) {
    var wmsg;

    switch (bookType) {
      case enumBookType.pdf:
        wmsg = "createpdf";
        this.fForceAspectRatio = null;
        this.SetXMLOutputType(enumXMLType.PDF);
        break;
      case enumBookType.ppt:
        wmsg = "createppt";
        this.SetXMLOutputType(enumXMLType.PPT);
        break;
      case enumBookType.googleslides:
        var wsMgr = this.fWSMgr;
        var googleAuthRFC = new QGoogleAuthRFC();
        googleAuthRFC.InitGoogleAuth(this);
        googleAuthRFC.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName());
        Globals._rfcMgr.QueueRFC(googleAuthRFC);

        wmsg = "creategoogleslides";
        this.fForceAspectRatio = { fX: 16, fY: 9 };
        this.SetXMLOutputType(enumXMLType.PPT);
        break;
      case enumBookType.xml:
        wmsg = "createxml";
        break;
    }

    this.fBookType = bookType;

    Globals._publishRef = this;
    this.fPubScope = pubScope;
    setTimeout(function () {
      handleBookAdvance(wmsg);
    }, 0);
  }

  UpdateProgress2(msg, hideCancel) {
    this.fWaiting.UpdateMessage(msg);
    if (hideCancel) this.fWaiting.HideCancel();
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fWSMgr.RenderWS();
  }

  DoPageLimitWarning(numPages) {
    var wsmgr = this.fWSMgr;
    var m = appstr("publimit1") + " " + numPages.toString() + " " + appstr("publimit2");

    var AP = new QAlert();
    AP.InitConfirmAlert(appstr("Alert"), m, this, wsmgr, "OKLargePub", "CancelLargePub");
    AP.SetPostCancelCode("CancelLargePub");

    ReportToWebDriver("Fail - Over Page Limit");
    wsmgr.PrepRenderWS();
    wsmgr.RenderWS();
  }

  ExecuteAlertCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();

    var handled = false;
    switch (theCode) {
      case "OKLargePub":
        var wmsg = "";
        switch (this.fBookType) {
          case enumBookType.pdf:
            wmsg = "createpdf";
            break;
          case enumBookType.ppt:
            wmsg = "createppt";
            break;
          case enumBookType.googleslides:
            wmsg = "creategoogleslides";
            break;
        }
        this.DoWaiting(appstr(wmsg), true);
        setTimeout(function () {
          doPagePreFlight();
        }, 1);
        handled = true;
        break;
      case "CancelLargePub":
        this.RemoveWaiting(false);
        this.CancelAction();
        handled = true;
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  PreFlightPDF(wmsg) {
    const pubScaler = new QPublishScaler();
    pubScaler.InitScaler(this.fForceAspectRatio, this.fOptimizeMode);
    Globals._publishScaler = pubScaler;

    var pubScope = this.fPubScope;

    var theDoc = this.fWSMgr.GetDoc();
    if (pubScope === enumBookScope.entire || pubScope === enumBookScope.branch)
      theDoc.SetRequestedLevels(2);
    var scm = theDoc.GetSubChartMgr();
    this.fCurShowSCNum = theDoc.ShowSubChartNum();

    var curSubChart = scm.GetCurrentSubChart();
    this.fCurrentSC = curSubChart;

    if (pubScope != enumBookScope.entire) scm.SetBranchRoot(curSubChart, pubScope);

    var numPages = scm.GetActiveBranchPages();
    var cp = this.fCanvasPanel;
    if (pubScope == enumBookScope.alldivisions) {
      numPages = 0;
      var startDoc = 0; //TODO: Should be 0
      var docMgr = this.fWSMgr.GetDocMgr();
      var numdocs = docMgr.GetNumDocuments();
      for (var n = startDoc; n < numdocs; n++) {
        var theDoc = docMgr.GetIndexDoc(n);
        var thescm = theDoc.GetSubChartMgr();
        scm.fBranchRoot = null;
        const docPages = thescm.GetActiveBranchPages();
        for (let dp = 0; dp < docPages; dp++) {
          const forceLayoutSC = thescm.GetSubChartByPageNum(dp + 1);
          if (forceLayoutSC) forceLayoutSC.SetNeedOptimize(true);
        }
        numPages += docPages;
      }
      var theDoc = docMgr.GetIndexDoc(startDoc);
      var docName = theDoc.GetDivisionName();
      this.fWSMgr.SwitchToDivision(docName, true);

      cp = theDoc.fCanvasRef;
      cp.SetShownState(false);
    }
    var plm = cp.GetPageLayoutMgr();

    var pageMgr = theDoc.GetPageMgr();
    var margRect = pageMgr.GetPageMarginsInt(true);
    var pWidth = pageMgr.GetMinPageWidth();
    var pHeight = pageMgr.GetMinPageHeight();
    //Not sure if we want this
    if (
      Globals._pubSettings.fShowActivity != "Off" &&
      Globals._uiConfig.GetUIMode() === enumUIModes.planning
    ) {
      var planMgr = this.fWSMgr.fPlanManager;
      if (planMgr != null) margRect = planMgr.AddDocPubMargin(pageMgr.GetPageProps(), margRect);
    }

    // Force re-layout for every page before publish (OCN5-6585). alldivisions is handled
    // per-document above since each document's subcharts are numbered locally.
    if (pubScope != enumBookScope.alldivisions) {
      for (let p = 0; p < numPages; p++) {
        const forceLayoutSC = scm.GetSubChartByPageNum(p + 1);
        if (forceLayoutSC) forceLayoutSC.SetNeedOptimize(true);
      }
    }

    var maxWidth = null;
    var maxHeight = null;
    var widthInches = null;
    var heightInches = null;

    if (this.fBookType == enumBookType.googleslides) {
      // pWidth = 960;
      // pHeight = 540;
      maxWidth = 10 * 72;
      maxHeight = 5.63 * 72;
    } else if (this.fXMLOutputType == enumXMLType.PPT) {
      var pageOpt = theDoc.GetDocPrefs().GetPageOpt();
      var aspect = pageOpt.GetAspectRatio();
      if ([5, 7].includes(aspect)) {
        if (aspect === 5) {
          Globals._publishScaler.fForceAspectRatio = { fX: 4, fY: 3 };
          widthInches = 10;
          heightInches = 7.5;
        }
        if (aspect === 7) {
          Globals._publishScaler.fForceAspectRatio = { fX: 16, fY: 9 };
          widthInches = 10;
          heightInches = 5.625;
        }
        maxWidth = widthInches * 72;
        maxHeight = heightInches * 72;
      } else {
        maxWidth = 4032; // this is the max of ppt slide (=56 in * 72 dpi)
        maxHeight = 4032;
      }
    }

    Globals._publishScaler.SetBasePageProps(pWidth, pHeight, maxWidth, maxHeight, margRect);

    Globals._preflightInfo = new preFlightInfo();
    Globals._preflightInfo.fNameList = new Set();
    Globals._preflightInfo.fSCM = scm;
    Globals._preflightInfo.fPLM = plm;
    Globals._preflightInfo.fCanvasPanel = cp;
    Globals._preflightInfo.fPubPanel = this;
    Globals._preflightInfo.fShowSCNum = false;
    Globals._preflightInfo.fNumPages = numPages;
    Globals._preflightInfo.fPageIndex = 0;
    Globals._preflightInfo.fXMLOutputType = this.fXMLOutputType;

    if (pubScope == enumBookScope.alldivisions) {
      Globals._preflightInfo.fCurDocIdx = startDoc;
      Globals._preflightInfo.fCompletedPages = 0;
    }

    if (numPages > 200 && !Globals._accountInfo.ReportToWebDriver())
      this.DoPageLimitWarning(numPages);
    else {
      this.DoWaiting(appstr(wmsg), true);
      setTimeout(function () {
        doPagePreFlight();
      }, 1);
    }
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
  }

  DoPublishBookComplete(showSCNum, xmlType) {
    var page_size = Globals._publishScaler.GetOutputPageSize();
    var theDoc = this.fWSMgr.GetDoc();
    if (!this.fCurShowSCNum && this.fCurShowSCNum != showSCNum)
      theDoc.SetShowSubChartNumBM(showSCNum);

    //var pubType = this.fPubBranch? enumLastDocGen.branch:enumLastDocGen.book;
    var uploadRFC = new QCreatePubDoc(); // QCreatePDFDoc();

    uploadRFC.InitCreatePubDoc(this, xmlType); //,pubType,

    var filename = this.fFileName;

    var pubFileName = xmlType == enumXMLType.PDF ? this.fPDFFileName : this.fPPTFileName;
    var overwriteDoc = false;
    if (pubFileName != null) {
      filename = StripExtension(pubFileName);
      overwriteDoc = true;
    }

    var pageWidth = page_size.fX;
    var pageHeight = page_size.fY;
    this.fPubWidth = pageWidth;
    this.fPubHeight = pageHeight;

    var xml_Doc = XML_CreateDoc(pageWidth, pageHeight, xmlType);
    this.PostBook(uploadRFC, filename, overwriteDoc, pageWidth, pageHeight, xml_Doc);
  }

  PostBook(transaction, filename, overwrite, pageWidth, pageHeight, outputDocRef) {
    var scm = this.fCanvasPanel.GetSubChartMgr();
    //var curSC = scm.GetCurrentSubChart();
    var pubScope = this.fPubScope;
    //if (pubScope != enumBookScope.entire)
    //   scm.SetBranchRoot(curSC,pubScope);

    var numPages = Globals._preflightInfo.fNumPages;
    var p = new bookRenderInfo();
    p.fPubPanel = this;
    p.fPageRetryQ = [];
    p.fPageWidth = pageWidth;
    p.fPageHeight = pageHeight;
    p.fPageList = new Array(numPages);
    p.fFileName = filename;
    p.fTransaction = transaction;
    p.fOverwrite = overwrite;
    p.fCurrentSC = this.fCurrentSC; // curSC;
    p.fBranchPages = numPages;
    //p.fWorkingSC = null;
    p.fWorkingStep = enumPageStep.masterStep;
    p.fWorkingPage = null;
    p.fWorkingLayer = null;
    p.fPubScope = pubScope;
    p.fOutputDocRef = outputDocRef;

    for (var i = 0; i < numPages; i++) p.fPageRetryQ.push(i);
    if (
      (Globals._pubSettings.fDoIndex &&
        pubScope == enumBookScope.entire &&
        scm.GetIndexPageSubChart()) ||
      (Globals._pubSettings.fDoFunctionStatements && scm.GetIndexPageSubChart())
    ) {
      if (scm.GetIndexPageSubChart().fChildren.length > 0)
        p.fPageRetryQ = p.fPageRetryQ.concat(
          scm.GetIndexPageSubChart().fChildren.map(function (a) {
            return a.GetSubChartID();
          })
        );
      numPages += scm.GetIndexPageSubChart().fChildren.length;
    }
    //this.AddBookmarkInfo(p);
    p.fNumPages = numPages;
    Globals._bookRenderInfo = p;
    startprtimer();
    setTimeout(function () {
      doPageRender();
    }, 0);
  }

  ResetPub(doShow) {
    var scm = this.fCanvasPanel.GetSubChartMgr();
    scm.SetBranchRoot(null, enumBookScope.entire);

    var theDoc = this.fWSMgr.GetDoc();
    theDoc.SetShowSubChartNumBM(false);

    var cp = this.fCanvasPanel;
    if (this.fCurrentSC) cp.SwitchToSubChartByObj(this.fCurrentSC);
    cp.fBackgroundPanel.SetHasVertScrollBar(false);

    if (doShow) {
      // adding defensive check here so canvas can't get into a bad state. prior render mode is captured in setpubpanel which is common to all export types
      var rm = this.fPriorRM != null ? this.fPriorRM : enumPanelRenderMode.all;
      cp.SetShownState(true);
      cp.SetRenderMode(rm);
    }
    if (this.fWSMgr.fTopToolbarRibbon) this.fWSMgr.fTopToolbarRibbon.ResetToolbars();
    this.fWSMgr.PrepRenderWS();
    this.fWSMgr.RenderWS();
  }

  DoPostBook(postAction) {
    var g = Globals._bookRenderInfo;
    var pp = g.fPubPanel;

    var bookType = pp.GetBookType();
    if (postAction == "final") {
      Globals._bookRenderInfo = null;
      this.ResetPub(false);
      Globals._publishRef = null;
    }
    var doc = this.fCanvasPanel.fDoc;
    if (
      bookType == enumBookType.pdf ||
      bookType == enumBookType.ppt ||
      bookType == enumBookType.googleslides
    ) {
      var xml_doc = g.fOutputDocRef;
      if (postAction == "final") xml_doc.Close();
      var theData = xml_doc.JoinStream3();
      if (postAction == "append") xml_doc.ResetStream();

      var curOrg = this.fWSMgr.GetAccountName();

      var pageWidth = pp.fPubWidth;
      var pageHeight = pp.fPubHeight;

      var jsonData = {};
      jsonData["org"] = curOrg;
      jsonData["dtype"] = bookType;
      jsonData["filename"] = g.fFileName;
      jsonData["width"] = pageWidth;
      jsonData["height"] = pageHeight;
      jsonData["overwrite"] = g.fOverwrite;
      jsonData["bkgrnd"] = true;
      jsonData["thedata"] = theData;
      jsonData["action"] = postAction;
      jsonData["xmlname"] = g.fTransaction.GetXMLFileName();

      if (doc && doc.GetChartID()) jsonData["chartID"] = doc.GetChartID();

      var j = JSON.stringify(jsonData);

      var postData = SecureBufferW(pp.fWSMgr, j);

      g.fTransaction.SetPostAction(postAction);
      g.fTransaction.SetPostBuffer(postData);
      Globals._rfcMgr.QueueRFC(g.fTransaction);
    } else {
      this.XMLPost(g.fTransaction, false, g.fFileName, g.fOverwrite, g.fOutputDocRef);
    }
  }

  //var enumXMLType = { PDF: 0, PPT: 1};
  PublishDocResult(failure, pubFile, outputType, postAction) {
    if (failure) {
      if (outputType == enumXMLType.PDF) this.fPDFFileName = null;
      else this.fPPTFileName = null;
      this.ReportExportFailure(failure);
      return;
    }

    if (postAction == "append") {
      doPageRender();
      return;
    }

    this.RemoveWaiting(true);

    if (outputType == enumXMLType.PDF) {
      //	this.fNeedGenPDF = false;
      this.fPDFFileName = pubFile;
      //this.fLastPDFGen = outputType;
    } else {
      //	this.fNeedGenPPT = false;
      this.fPPTFileName = pubFile;
      //	this.fLastPPTGen = outputType;
    }

    this.DoOutput(pubFile);
  }

  //=======================================================================================
  PostPage(transaction, filename, overwrite, pageWidth, pageHeight, xmlType, includeBackground) {
    var cropToChart = this.fCropToChart;
    this.CalcCanvasParams(cropToChart);

    pageWidth = this.fPubWidth;
    pageHeight = this.fPubHeight;

    var xml_doc = XML_CreateDoc(pageWidth, pageHeight, xmlType); //  enumXMLType.PDF
    this.RenderXML(
      null,
      false,
      true,
      pageWidth,
      pageHeight,
      xml_doc,
      1,
      null,
      enumRenderStep.openandclose,
      1
    );
    xml_doc.Close();
    var theData = xml_doc.JoinStream();
    var curOrg = this.fWSMgr.GetAccountName();

    var jsonData = {};
    jsonData["org"] = curOrg;
    jsonData["dtype"] = xmlType;
    jsonData["filename"] = filename;
    jsonData["width"] = pageWidth;
    jsonData["height"] = pageHeight;
    jsonData["overwrite"] = overwrite;
    jsonData["bkgrnd"] = includeBackground;

    jsonData["thedata"] = theData;
    var j = JSON.stringify(jsonData);

    var postData = SecureBufferW(this.fWSMgr, j, true);
    transaction.SetPostBuffer(postData);
    Globals._rfcMgr.QueueRFC(transaction);
  }

  LookupPageSizeinPixels(pageSize, pageOrientation) {
    var p = new QPoint();
    var n = kPDFPageSizes.length;
    for (var i = 0; i < n - 1; i++) {
      if (pageSize == kPDFPageSizes[i][1]) {
        var w = kPDFPageSizes[i][2];
        var h = kPDFPageSizes[i][3];
        if (pageOrientation == enumPageOrientationOptions.landscape) {
          var t = w;
          w = h;
          h = t;
        }
        p.InitPoint(w, h);
        return p;
      }
    }

    return this.GetCustomPDFSize();
  }

  //=======================================================================================
  // Transaction to push the SVG image to the server and then render it as PNG Image
  DoSVGUpload(theData, createAlt, transparent, hiresPNG, overwriteAlt) {
    var uploadRFC = new QCreateSVGRFC();
    uploadRFC.InitCreateSVGRFC(this);
    uploadRFC.SetHIRESPNG(hiresPNG);

    var w = this.fWSMgr;
    var curOrg = w.GetAccountName();
    var curUser = w.GetUserName();
    var filename = this.fFileName; // + ".svg";

    var overwriteSVG = false;
    if (this.fSVGFileName != null) {
      filename = StripExtension(this.fSVGFileName);
      overwriteSVG = true;
    }

    var jsonData = {};
    jsonData["org"] = curOrg;
    jsonData["filename"] = filename;
    jsonData["width"] = this.fPubWidth;
    jsonData["height"] = this.fPubHeight;
    jsonData["createAlt"] = createAlt;
    jsonData["transparent"] = transparent;
    jsonData["hiresPNG"] = hiresPNG;
    jsonData["overwriteAlt"] = overwriteAlt;
    jsonData["overwriteSVG"] = overwriteSVG;
    jsonData["thedata"] = theData;
    var doc = this.fCanvasPanel.fDoc;
    if (doc && doc.GetChartID()) jsonData["chartID"] = doc.GetChartID();
    var j = JSON.stringify(jsonData);
    var postData = SecureBufferW(w, j);

    uploadRFC.SetPostBuffer(postData);
    Globals._rfcMgr.QueueRFC(uploadRFC);
  }

  //=======================================================================================
  PublishSVG(cropToChart, createAlt, createPreview, transparent, hires, overwrite) {
    var s = appstr("createsvg");
    if (createAlt.length > 0) s = appstr("Creating") + " " + createAlt + "...";

    this.DoWaiting(s, false);
    this.DoPublishSVG(cropToChart, createAlt, createPreview, transparent, hires, overwrite);
  }

  DoPublishSVG(cropToChart, createAlt, createPreview, transparent, hires, overwrite) {
    this.fCreatePreview = createPreview;

    var ri = new svgRenderInfo();
    ri.fCanvasPanel = this.fCanvasPanel;
    ri.fCurDoc = this.fWSMgr.GetDoc();
    ri.fPublishPanel = this;
    ri.fCropToChart = cropToChart;
    ri.fCreateAlt = createAlt;
    ri.fCreatePreview = createPreview;
    ri.fTransparent = transparent;
    ri.fHires = hires;
    ri.fOverwrite = overwrite;
    Globals._svgRenderInfo = ri;

    doSVGRender();

    //this.CreateSVGElement(cropToChart,transparent);

    /*
	var s = this.CreateSVGElement(cropToChart,transparent);
	var svgData = MyXMLSerializer(s);
	var svg_dataurl = ubtoa(svgData);
	this.DoSVGUpload(svg_dataurl, createAlt,transparent, hires,overwrite);
	*/
  }

  FinishPublishSVG(s) {
    var svgData = MyXMLSerializer(s);
    //var svg_dataurl = ubtoa(svgData);

    //this.DoSVGUpload(svg_dataurl, Globals._svgRenderInfo.fCreateAlt,Globals._svgRenderInfo.fTransparent, Globals._svgRenderInfo.fHires,Globals._svgRenderInfo.fOverwrite);
    var ri = Globals._svgRenderInfo;
    this.DoSVGUpload(svgData, ri.fCreateAlt, ri.fTransparent, ri.fHires, ri.fOverwrite);
    Globals._svgRenderInfo = null;
  }

  HandleAutoZoom() {
    DoAutoZoom(this.fBackgroundPanel, this);
    this.DoCustomResize();
  }

  //=======================================================================================
  SVGResult(failure, svgFile, altFile, HIRESPNG) {
    if (failure) {
      this.ReportExportFailure(failure);
      return;
    }
    this.RemoveWaiting(true);

    this.fSVGFileName = svgFile;
    this.fNeedGenSVG = false;
    var downloadFile = null;

    if (altFile != null) {
      var ext = GetExtension(altFile);
      if (ext == "png") {
        this.fPNGFileName = altFile;
        this.fNeedGenPNG = false;
        this.fHIRESPNG = HIRESPNG;
      } else {
        this.fJPGFileName = altFile;
        this.fNeedGenJPG = false;
      }

      if (this.fCreatePreview) {
        var anImage = new Image();
        anImage["parentWS"] = this.fWSMgr;
        anImage.onload = WSImageLoaded;

        var curOrg = this.fWSMgr.GetAccountName();

        var d = new Date();
        var v = d.getTime(); // Overrides the browser caching

        anImage.src = "preview/" + curOrg + "/" + altFile + "?time=" + v; // new Date();

        //var pageMgr = this.fCanvasPanel.GetPageMgr();
        var pageWidth = this.fCanvasSizeX; // pageMgr.GetCanvasWidth();
        var pageHeight = this.fCanvasSizeY; // pageMgr.GetCanvasHeight();

        var imageElement = new QImageElement();
        imageElement.SetImage(anImage);
        imageElement.SizeElement(pageWidth, pageHeight);
        imageElement.PositionElement(0, 0);
        imageElement.SetResizeBehavior(true, true, true, true);
        this.PushElement(imageElement);
        this.HandleAutoZoom();
      } else downloadFile = altFile;
    } else downloadFile = svgFile;

    if (downloadFile != null) this.DoOutput(downloadFile);
  }

  InitPublish(fileName, backgroundPanel, wsMgr, canvasPanel) {
    if (fileName == null) fileName = appstr("Untitled");

    this.fFileName = this.CleanFileName(fileName); // fileName;
    this.fWSMgr = wsMgr;
    this.fCanvasPanel = canvasPanel;
    this.InitBasePanel(backgroundPanel);
    this.SetPanelMode(enumPanelMode.panMode);

    var cp = this.fCanvasPanel;
    var plm = cp.GetPageLayoutMgr();
    this.fCanvasSizeX = plm.GetPageWidth(); // OK
    this.fCanvasSizeY = plm.GetPageHeight();

    wsMgr.PushPanel(this);
    this.DoPublishSVG(false, "PNG", true, false, false, false);
    this.DoCustomResize();
    this.DoWaiting(appstr("createpreview"), false);
    this.fWSMgr.SetKeyboardTarget(null, this, enumKeyboardTargetEnterAction.none);
  }

  DoOutput(filename) {
    var w = this.fWSMgr;
    var docMgr = w.GetDocMgr();
    var pubDest = enumPubDest.download;
    var pubDestFolder = null;
    if (Globals._svrChartMgr.fOverridePubDest) {
      //Hardcoded when automated process performs refresh. Can adjust later.
      pubDest = Globals._svrChartMgr.fOverridePubDest;
    } else if (this.fBookType === enumBookType.googleslides) pubDest = enumPubDest.nodownload;

    if (!Globals._accountInfo.ReadOnlyMode()) {
      var docPrefs = docMgr.GetDocPrefs();
      pubDest = docPrefs.GetPubDest();
      pubDestFolder = docPrefs.GetPubDestFolder();
    }

    switch (pubDest) {
      case enumPubDest.download:
        this.DoDownload(filename);
        break;
      case enumPubDest.folder:
        this.CopyToFolder(filename, pubDestFolder);
        break;
      case enumPubDest.nodownload:
        ReportToWebDriver("pubready^" + filename);
        if (this.fBookType === enumBookType.googleslides) {
          var slidesName = "'" + filename.split(".")[0] + "'";
          var text =
            slidesName +
            " was successfully uploaded to the 'OrgChart' folder in your Google Drive.";
          var alert = new QGoogleAlert();
          alert.InitConfirmAlertCustom(
            "Export Successful",
            text,
            this.fBackgroundPanel,
            w,
            "OKLaunchDrive",
            "Cancel",
            appstr("Open") + " " + "Google Drive",
            "Close Alert"
          );
          w.RenderWS();
        }
        break;
    }
    this.DoAfterPublish();
  }

  CopyPubResult(response) {
    Globals._pubPanel = this;
    Globals._pubPanel["response"] = response;

    setTimeout(function () {
      FinishPubResult();
    }, 500);
  }

  CopyToFolder(filename, dstFolder) {
    //  dstFolder = "Portal";
    var ext = GetExtension(filename);
    var dstName = this.fFileName + "." + ext;

    var s = appstr("copypubfolder") + " '" + dstFolder + "'";
    this.DoWaiting(s, false);

    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();

    var copyPubRFC = new QCopyPubRFC();
    copyPubRFC.InitCopyPubRFC(this);
    copyPubRFC.SetParams(org, user, dstFolder, filename, dstName);
    Globals._rfcMgr.QueueRFC(copyPubRFC);
  }

  DoDownload(filename) {
    //curOrg = this.fWSMgr.GetAccountName();
    //filename = encodeURIComponent(filename);
    //curOrg = encodeURIComponent(curOrg);
    //var theURL = "/ServerSide/qdownloadpublish?org=" + curOrg + "&filename=" + filename;
    //window.location.assign(theURL);

    var w = this.fWSMgr;
    w.DownloadPub(filename);
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
  }

  PrepDownloadSVG() {
    if (this.fCropToChart != Globals._pubSettings.fCropToChart) {
      this.fNeedGenSVG = true;
      this.fCropToChart = Globals._pubSettings.fCropToChart;
    }

    if (this.fTransparent != Globals._pubSettings.fTransparentBackground) {
      this.fNeedGenSVG = true;
      this.fTransparent = Globals._pubSettings.fTransparentBackground;
    }
  }

  PrepDownloadJPG() {
    if (this.fCropToChart != Globals._pubSettings.fCropToChart) {
      this.fNeedGenJPG = true;
      this.fCropToChart = Globals._pubSettings.fCropToChart;
    }
  }

  PrepDownloadPNG(theCode) {
    if (this.fTransparent != Globals._pubSettings.fTransparentBackground) {
      this.fNeedGenPNG = true;
      this.fTransparent = Globals._pubSettings.fTransparentBackground;
    }

    if (this.fCropToChart != Globals._pubSettings.fCropToChart) {
      this.fNeedGenPNG = true;
      this.fCropToChart = Globals._pubSettings.fCropToChart;
    }

    if (this.fNeedGenPNG == false) {
      var isHIRES = this.fHIRESPNG;
      if (theCode == "DownloadHIRESPNG" && isHIRES) return;
      if (theCode == "DownloadPNG" && !isHIRES) return;

      this.fNeedGenPNG = true;
    }
  }

  ToggleTrans() {
    this.fNeedGenPNG = true;
    this.fNeedGenSVG = true;

    Globals._pubSettings.fTransparentBackground = !Globals._pubSettings.fTransparentBackground;
  }

  ToggleCrop() {
    this.fNeedGenSVG = true;
    this.fNeedGenPNG = true;
    this.fNeedGenJPG = true;

    Globals._pubSettings.fCropToChart = !Globals._pubSettings.fCropToChart;
  }

  SetXMLOutputType(xmlOutputType) {
    this.fXMLOutputType = xmlOutputType;
  }

  GetXMLOutputType() {
    return this.fXMLOutputType;
  }

  SetPubOptions(hideMaster, outputBackgrnd, aspectRatio, optimizeMode) {
    this.fTransparent = !outputBackgrnd;
    this.fHideMaster = hideMaster;
    this.fForceAspectRatio = aspectRatio;
    this.fOptimizeMode = optimizeMode;
  }

  HandleDownload(theCode) {
    return new Promise(resolve => {
      this.DoHandleDownload(theCode);
      this.fResolve = resolve;
    });
  }

  DoHandleDownload(theCode) {
    window.onbeforeunload = null;
    this.fWSMgr.SetIgnoreExit(true);
    var docMgr = this.fWSMgr.GetDocMgr();
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
    var filename = "";

    if (
      Globals._pubSettings.fTransparentBackground !== this.fTransparent ||
      theCode === "DownloadJPG"
    ) {
      Globals._pubSettings.fTransparentBackground = this.fTransparent;

      this.fNeedGenPNG = true;
      this.fNeedGenSVG = true;
      this.fNeedGenJPG = true;
      if (theCode === "DownloadJPG" && this.fTransparent) {
        var bkSave = docMgr.GetBackgroundColor();
        var bkSave2 = docMgr.GetBackgroundColor2();
        docMgr.SetBackgroundColor("#FFFFFF");
        docMgr.SetBackgroundColor2("#FFFFFF");
      }
    }
    switch (theCode) {
      case "DownloadSVG":
        this.PrepDownloadSVG();
        if (this.fNeedGenSVG)
          this.PublishSVG(
            this.fCropToChart,
            "",
            false,
            Globals._pubSettings.fTransparentBackground,
            false,
            true
          );
        else filename = this.fSVGFileName;
        break;
      case "DownloadPNG":
      case "DownloadHIRESPNG":
        this.PrepDownloadPNG(theCode);
        if (this.fNeedGenPNG)
          this.PublishSVG(
            this.fCropToChart,
            "PNG",
            false,
            Globals._pubSettings.fTransparentBackground,
            theCode == "DownloadHIRESPNG",
            true
          );
        else filename = this.fPNGFileName;
        break;
      case "DownloadJPG":
        this.PrepDownloadJPG();
        if (this.fNeedGenJPG) {
          this.PublishSVG(this.fCropToChart, "JPG", false, false, false, true);
          if (Globals._pubSettings.fTransparentBackground) {
            docMgr.SetBackgroundColor(bkSave);
            docMgr.SetBackgroundColor2(bkSave2);
          }
        } else filename = this.fJPGFileName;
        break;
      case "DownloadPagePDF":
        this.PublishBook(enumBookScope.page, enumBookType.pdf);
        break;
      case "DownloadBranchPDF":
        this.PublishBook(enumBookScope.branch, enumBookType.pdf);
        break;
      case "DownloadBookPDF":
        this.PublishBook(enumBookScope.entire, enumBookType.pdf);
        break;
      case "DownloadMultiChartPDF":
        this.PublishBook(enumBookScope.alldivisions, enumBookType.pdf);
        break;
      case "DownloadPagePPT":
        this.PublishBook(enumBookScope.page, enumBookType.ppt);
        break;
      case "DownloadBranchPPT":
        this.PublishBook(enumBookScope.branch, enumBookType.ppt);
        break;
      case "DownloadBookPPT":
        this.PublishBook(enumBookScope.entire, enumBookType.ppt);
        break;
      case "DownloadMultiChartPPT":
        this.PublishBook(enumBookScope.alldivisions, enumBookType.ppt);
        break;
      case "DownloadPageGOOGLESLIDES":
        this.PublishBook(enumBookScope.page, enumBookType.googleslides);
        break;
      case "DownloadBranchGOOGLESLIDES":
        this.PublishBook(enumBookScope.branch, enumBookType.googleslides);
        break;
      case "DownloadBookGOOGLESLIDES":
        this.PublishBook(enumBookScope.entire, enumBookType.googleslides);
        break;
      case "DownloadMultiChartGOOGLESLIDES":
        this.PublishBook(enumBookScope.alldivisions, enumBookType.googleslides);
        break;
      default:
        // This should never happen
        return;
    }

    if (filename.length > 0) this.DoOutput(filename);

    SetOnBeforeUnload();
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fWSMgr.fBackgroundPanel.SetHasHorzScrollBar(false);
  }

  Cleanup() {
    this.fCanvasPanel = null;
    this.fCurrentSC = null;

    var cleanupRFC = new QCleanupPublishRFC();
    cleanupRFC.InitCleanupRFC();
    Globals._pubSettings.fTransparentBackground = false;
    var w = this.fWSMgr;
    var curOrg = w.GetAccountName();
    var curUser = w.GetUserName();
    var fileList = [
      this.fSVGFileName,
      this.fPNGFileName,
      this.fJPGFileName,
      this.fXMLFileName,
      this.fPDFFileName,
      this.fPPTFileName
    ];
    cleanupRFC.SetParams(curOrg, curUser, fileList);
    Globals._rfcMgr.QueueRFC(cleanupRFC);
  }

  //=====================================================================================
  // Zoom, Pan and Resize
  SupportsZoom() {
    return true;
  }

  DoCustomResize() {
    this.DoResizeCanvas();

    var scaleFactor = this.GetScaleFactor();
    var portWidth = this.fPortWidth;
    var canvasWidth = this.fCanvasSizeX;

    var unscaledPortWidth = Math.round(portWidth / scaleFactor);
    var maxPanX = canvasWidth - unscaledPortWidth;

    var panY = 0;
    var panX = Math.round(maxPanX / 2);

    if (panX < 0) panX = 0;

    this.SetPanX(panX);
    this.SetPanY(panY);
  }

  ResizeCanvasCenter(priorScaleFactor) {
    var priorPanX = this.GetPanX();
    var priorPanY = this.GetPanY();
    var priorPortWidth = this.fPortWidth;
    var priorPortHeight = this.fPortHeight;

    this.DoResizeCanvas();

    this.UpdatePanOffset(priorPanX, priorPanY, priorPortWidth, priorPortHeight, priorScaleFactor);
  }

  CleanFileName(filename) {
    var f = StripExtension(filename);
    f = f.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "_");
    f = removeDiacritics(f);
    f = f.replace(/[^\x00-\x7F]/g, "_"); //  This code replaces all characters in filename that are not in the ascii range 0 - 127 (0X7F is 127 in hex)
    return f.substring(0, kMaxStringLength);
  }

  SetPDFPageSize(pageSize) {
    if (this.fPDFPageSize != pageSize) {
      this.fPDFPageSize = pageSize;
      //this.fNeedGenPDF = true;
    }
  }

  SetPDFOrientation(orientation) {
    if (this.fPDFOrientation != orientation) {
      this.fPDFOrientation = orientation;
      //this.fNeedGenPDF = true;
    }
  }

  GetPDFPageSize() {
    return this.fPDFPageSize;
  }

  GetPDFOrientation(orientation) {
    return this.fPDFOrientation;
  }

  SetCustomPDFSize(w, h) {
    this.fPDFCustomSize = new QPoint();
    this.fPDFCustomSize.InitPoint(w, h);
  }

  GetCustomPDFSize() {
    return this.fPDFCustomSize;
  }

  SetPubPanel(doTransparent, fileName, wsMgr) {
    this.fWSMgr = wsMgr;
    var curDoc = wsMgr.GetDoc();
    var pageMgr = curDoc.GetPageMgr();
    var pOrientation = pageMgr.GetPageOrientation();

    var pWidth, pHeight;
    var plm = curDoc.GetPageLayoutMgr();

    {
      pWidth = pageMgr.GetMinPageWidth();
      pHeight = pageMgr.GetMinPageHeight();
    }

    var ps = MapPageSizeToString(pWidth, pHeight, pOrientation);

    var isServerChart = curDoc.IsServerChart();

    var curFileName = fileName;
    if (isServerChart && !curFileName) {
      //I don't have my own name!
      var scm = curDoc.GetSubChartMgr();
      var sc =
        Globals._pubSettings.fPubScope === "Book"
          ? scm.GetRootSubChart()
          : scm.GetCurrentSubChart();
      curFileName = sc.GetSubChartName();
    } else if (!curFileName) {
      var docMgr = wsMgr.GetDocMgr();
      curFileName = docMgr.GetFileName(true);
      if (curFileName == null) {
        curFileName = appstr("Untitled");
      }
    }

    this.fFileName = this.CleanFileName(curFileName);
    this.fWSMgr = wsMgr;
    this.fCanvasPanel = wsMgr.fCanvasPanel;
    this.fBackgroundPanel = wsMgr.fBackgroundPanel;
    this.fCanvasSizeX = plm.GetPageWidth(); // OK
    this.fCanvasSizeY = plm.GetPageHeight();
    this.fPriorRM = this.fCanvasPanel.GetRenderMode();
    this.SetPDFOrientation(pOrientation);
    this.SetPDFPageSize(ps);

    this.fTransparent = Globals._pubSettings.fTransparentBackground;
    this.fDoSCArrows = Globals._pubSettings.fDynNav;
    var optimizeMode = Globals._pubSettings.fDocPrintMode;

    var doBackground = doTransparent
      ? Globals._pubSettings.fTransparentBackground
      : Globals._pubSettings.fWhiteBackground;
    this.SetPubOptions(Globals._pubSettings.fHideMaster, !doBackground, false, optimizeMode);
  }
}
